/**
 * 25.08.2026 — НЕ УДАЛЯТЬ по требованию владельца: служебные пометки только superadmin, пациент не видит.
 * Separate admin fetch. Never enrich MessageDTO / websocket payloads.
 */
import { apiClient } from './client';

export type TrainingNoteKind = 'coaching' | 'unanswered' | 'should_reply' | 'suggest_kb' | 'other';
export type NotifierAnchorKind = 'conversation' | 'message';

export interface TrainingNote {
  id: string;
  tenant_id: string;
  anchor_kind: NotifierAnchorKind;
  anchor_id: string;
  anchor_offset?: number | null;
  observed_at?: string | null;
  note_kind: TrainingNoteKind;
  body: string;
  suggested_reply?: string | null;
  kb_hint?: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface TrainingNoteCreate {
  tenant_id: string;
  anchor_kind: NotifierAnchorKind;
  anchor_id: string;
  note_kind: TrainingNoteKind;
  body: string;
  suggested_reply?: string | null;
  kb_hint?: string | null;
  observed_at?: string | null;
}

export const trainingNotesApi = {
  listForChat: async (tenantId: string, conversationId: string, messageIds: string[]): Promise<TrainingNote[]> => {
    const { data } = await apiClient.get<{ items: TrainingNote[] }>('/admin/training-notes', {
      params: {
        tenant_id: tenantId,
        conversation_id: conversationId,
        message_ids: messageIds.join(','),
      },
    });
    return data.items || [];
  },

  listMine: async (from?: string, to?: string): Promise<TrainingNote[]> => {
    const { data } = await apiClient.get<{ items: TrainingNote[] }>('/admin/training-notes', {
      params: { mine: true, created_from: from, created_to: to },
    });
    return data.items || [];
  },

  create: async (payload: TrainingNoteCreate): Promise<TrainingNote> => {
    const { data } = await apiClient.post<TrainingNote>('/admin/training-notes', payload);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/training-notes/${id}`);
  },
};
